import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenubarModule} from 'primeng/menubar';
import {TranslateModule} from '@ngx-translate/core';
import {SecurityModule} from '../../security/security.module';
import {zAppBreadcrumbComponent} from './Breadcrumb.component';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {zAppDevIconismModule} from '@framework/components/Iconism/iconism.module';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ListboxModule} from "primeng/listbox";
import {FormsModule} from "@angular/forms";
import { BreadcrumbGraphService } from './BreadcrumbGraph.service';
import {RippleModule} from "primeng/ripple";
import {RouterLink, RouterLinkActive} from "@angular/router";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SecurityModule,
        MenubarModule,
        TieredMenuModule,
        zAppDevIconismModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ListboxModule,
        FormsModule,
        RippleModule,
        RouterLink,
        RouterLinkActive
    ],
    declarations: [zAppBreadcrumbComponent],
    exports: [zAppBreadcrumbComponent],
    providers:[BreadcrumbGraphService]
})
export class zAppDevBreadcrumbModule {
}
